import classNames from 'classnames';
import React from 'react';
import { Spinner } from 'wix-ui-tpa';
import { StatesButtonStates, StatesButton as TPAButton, TextButton as TPATextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';
import { SubmitButtonStyle } from '../../../../constants';
import { useConfig } from '../../../../contexts/config-context';
import { ForcedState, useForcedState } from '../../../../contexts/forced-state-context';
import { useForm } from '../../../../contexts/form-context';
import { getSubmitButtonStyle, useStyleParams } from '../../../../contexts/style-params-context';
import { FadeOut } from '../fade-out';
import { useSubmitButton } from '../use-submit-button';
import { getCurrentStep } from '../utils';
import { ErrorMessageWUT } from './error-message-wut';
import { NextButton } from './next-button';
import { PreviousButton } from './previous-button';
import { classes } from './submit-button-wut.st.css';
import { ThankYouMessageWUT } from './thank-you-message-wut';
const InProgressLoader = () => {
  return /*#__PURE__*/React.createElement(Spinner, {
    className: classes.spinner
  });
};
const Submit = _ref => {
  let {
    onClick,
    disabled,
    submitText,
    hasSteps,
    inProgress
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.SUBMIT_BUTTON_HOVER);
  const textButton = getSubmitButtonStyle(useStyleParams(), isMobile) === SubmitButtonStyle.Text;
  return textButton ? /*#__PURE__*/React.createElement(TPATextButton, {
    priority: TextButtonPriority.primary,
    className: classNames(classes.textButton, {
      [classes.textButtonHover]: hover,
      [classes.navigationButtons]: hasSteps
    }),
    onClick: onClick,
    disabled: disabled
  }, inProgress ? /*#__PURE__*/React.createElement(InProgressLoader, null) : submitText) : /*#__PURE__*/React.createElement(TPAButton, {
    className: classNames(classes.button, {
      [classes.hover]: hover,
      [classes.navigationButtons]: hasSteps
    }),
    upgrade: true,
    onClick: onClick,
    disabled: disabled,
    state: inProgress ? StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE,
    inProgressContent: /*#__PURE__*/React.createElement(InProgressLoader, null),
    idleContent: submitText
  });
};
export const SubmitButtonWUT = _ref2 => {
  let {
    submitText,
    text,
    id,
    thankYouMessageText,
    thankYouMessageDuration,
    externalUrl,
    externalUrlTarget,
    submitAction,
    forceThankYouMessage,
    previousText,
    nextText,
    FieldLayout
  } = _ref2;
  const {
    isMobile
  } = useConfig();
  const form = useForm();
  const {
    hasSteps,
    stepNumber,
    isLastStep
  } = getCurrentStep(form, id);
  const textButton = getSubmitButtonStyle(useStyleParams(), isMobile) === SubmitButtonStyle.Text;
  const {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    isThankYouMessageVisible,
    thankYouMessage,
    errorMessage,
    submitButtonText
  } = useSubmitButton({
    fieldId: id,
    thankYouMessageDuration,
    thankYouMessageText,
    forceThankYouMessage,
    externalUrl,
    externalUrlTarget,
    submitAction,
    text,
    submitText
  });
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => null,
    renderInput: () => /*#__PURE__*/React.createElement("div", {
      className: classNames({
        [classes.navigationContainer]: hasSteps,
        [classes.textButtonContainer]: !hasSteps && textButton
      })
    }, hasSteps && stepNumber !== 0 && /*#__PURE__*/React.createElement(PreviousButton, {
      previousText: previousText,
      className: classes.navigationButtons
    }), hasSteps && !isLastStep ? /*#__PURE__*/React.createElement(NextButton, {
      nextText: nextText,
      className: classes.navigationButtons
    }) : /*#__PURE__*/React.createElement(Submit, {
      onClick: handleSubmitClick,
      disabled: isDisabled,
      submitText: submitButtonText,
      hasSteps: hasSteps,
      inProgress: isInProgress
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FadeOut, {
      animate: isThankYouMessageVisible
    }, /*#__PURE__*/React.createElement(ThankYouMessageWUT, {
      messageText: thankYouMessage
    })), errorMessage && /*#__PURE__*/React.createElement(ErrorMessageWUT, {
      errorMessage: errorMessage
    }))
  });
};
//# sourceMappingURL=submit-button-wut.js.map